/**
 * Centralized route definitions for the application.
 * Use these constants instead of hardcoded strings for type safety and maintainability.
 */
export enum AppRoutes {
    WAITLIST = '/waitlist',
    HOME = '/',
    LOGIN = '/login',
    SIGNUP = '/signup',
    VERIFY = '/verify',
    PROFILE = '/profile',
    TUTOR_PROFILE = '/tutor-profile',
    STUDENT_PROFILE = '/student-profile',
    DASHBOARD = '/dashboard',
    BECOME_TUTOR = '/become-tutor',
    FORGOT_PASSWORD = '/forgot-password',
}
